import React, { useState, useEffect } from "react";
import { AppointmentService } from "../../services";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { Loader, Button } from "../shared";
import AppointmentCards from "./appointmentCards";
import { currentLanguage, logEvent } from "../../util/common";
import { useDispatch, useSelector } from "react-redux";
import { useAppNavigation } from "../../hooks";
import { toggleLoginModalVisibility } from "../../redux/reducers/componentReducer";

const BringItToTheExpert = () => {
  const { t } = useTranslation();
  const { localeRoutes, toSelectService, toUrlWithData } = useAppNavigation();
  const lang = currentLanguage();
  const location = useLocation();
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.user.details);

  const [loading, setLoading] = useState(false);
  const [appointments, setAppointments] = useState([]);

  const fetchAppointments = async (searchBy) => {
    setLoading(true);
    try {
      const bookings = await AppointmentService.getAppointments(searchBy ? "?" + searchBy : "");
      if (bookings) {
        setAppointments(bookings);
        const activeAppointment = bookings.some(
          ({ isCanceled, isExpired }) => !isCanceled && !isExpired
        );
        if (!activeAppointment) navigateToBook();
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userData.id) fetchAppointments();
    else dispatch(toggleLoginModalVisibility(true));
  }, [userData]);

  const navigateToBook = () => {
    logEvent("Appointment", "book_button_click", "Book a new appointment Button");
    if (location.state) toUrlWithData(localeRoutes.appointment[lang], location.state);
    else toSelectService();
  };

  return (
    <div>
      <Loader show={loading} />

      <section className="margin">
        <div className="container-fluid recent_main bring-it">
          <div className="row bring-it-appointments">
            <div className="titles">
              <h2>
                {loading ? t("track.gettingAppointments") : t("track.yourScheduledAppointments")}{" "}
              </h2>
            </div>

            {appointments?.length ? (
              appointments.map((appointment, index) => {
                return (
                  <AppointmentCards
                    key={index}
                    appointment={appointment}
                    fetchAppointments={fetchAppointments}
                  />
                );
              })
            ) : !appointments?.length ? (
              <div className="no-results">
                <h5 className="no-data">{t("track.noResultsToShow")}</h5>
              </div>
            ) : null}
          </div>

          <div className="book-btn-bring-it">
            <Button action={navigateToBook} type="big-roundedRight">
              {t("home.bringItToTheExpert")}
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BringItToTheExpert;
